<button (click)="login()">Continue with Google</button>
